interface ImageFallbackProps {
  subTitle?: string;
  iconSize?: number;
  className?: string;
}

export function ImageFallback({ subTitle, iconSize = 48, className }: ImageFallbackProps) {
  return (
    <div
      className={`flex h-full w-full select-none flex-col items-center justify-center gap-2 ${className ?? ''}`}
      style={{
        background: 'linear-gradient(to bottom, var(--color-mr-teal), var(--color-mr-teal-dark))',
      }}
    >
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="48" height="48" rx="6" fill="var(--color-mr-teal-hover)" />
        <text
          x="50%"
          y="54%"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="var(--color-mr-teal-light)"
          fontSize="20"
          fontWeight="700"
          letterSpacing="1"
        >
          MR
        </text>
      </svg>
      {subTitle ? (
        <span
          className="text-xs font-medium capitalize tracking-wide"
          style={{ color: 'rgba(91, 196, 191, 0.7)' }}
        >
          {subTitle.replace(/[_-]/g, ' ')}
        </span>
      ) : null}
    </div>
  );
}
